const COLORS = {
  Renters: "#f48232",
  "Rent like home": "#00a7e4",
  Apartview: "#ffc72c",
  One: "#f48232",
};

const white = "#ffffff";
const green = "#4aa96c";
const red = "#f55c47";
const gray = "#aaaaaa";
const blue = "#1e90ff";
const blueGrey = "#5b7ba4";
const yellow = "#ffdf6b";
const yellowBrown = "#846b00";

const COMPANY_INFO = {
  Renters: {
    name: "Renters sp. z o.o.",
    street: "Jana Sebastiana Bacha 26A",
    city: "02-743 Warszawa",
    nip: "NIP 5213782041",
  },
  "Rent like home": {
    name: "Polish Holiday Rentals sp. z o.o.",
    street: "ul. Jana Sebastiana Bacha 26A",
    city: "02-743 Warszawa",
    nip: "NIP 6762500419",
  },
  Apartview: {
    name: "Polish Holiday Rentals sp. z o.o.",
    street: "ul. Jana Sebastiana Bacha 26A",
    city: "02-743 Warszawa",
    nip: "NIP 6762500419",
  },
  One: {
    name: "Renters sp. z o.o.",
    street: "Jana Sebastiana Bacha 26A",
    city: "02-743 Warszawa",
    nip: "NIP 5213782041",
  },
};

const BRAND_LOGOS = {
  Renters: [{ src: "/Renters.png", height: 72, width: 72 }],
  "Rent like home": [
    { src: "/Renters.png", height: 72, width: 72 },
    { src: "/Rent like home.png", height: 30, width: 150 },
  ],
  Apartview: [{ src: "/Apartview.png", height: 60, width: 150 }],
  One: [{ src: "/Combined.png", height: 72, width: 372 }],
};

const CALENDAR_COLORS = {
  Renters: {
    owner: blue,
    "owner-tentative": blueGrey,
    unavailable: red,
    booked: green,
    available: white,
    default: white,
  },
  "Rent like home": {
    owner: yellow,
    "owner-tentative": yellowBrown,
    unavailable: gray,
    booked: red,
    available: green,
    default: red,
  },
  Apartview: {
    owner: yellow,
    "owner-tentative": yellowBrown,
    unavailable: gray,
    booked: red,
    available: green,
    default: red,
  },
  One: {
    owner: blue,
    "owner-tentative": blueGrey,
    unavailable: red,
    booked: green,
    available: white,
    default: white,
  },
};

const CUT_OFF = {
  Renters: {
    MONTHLY: {
      year: 2024,
      month: 6,
      from: "2024/06",
    },
    QUARTERLY: {
      year: 2024,
      month: 2,
      from: "2024/Q2",
    },
  },
  "Rent like home": {
    MONTHLY: {
      year: 2021,
      month: 4,
      from: "2021/04",
    },
    QUARTERLY: {
      year: 2024,
      month: 2,
      from: "2024/Q2",
    },
  },
  Apartview: {
    MONTHLY: {
      year: 2024,
      month: 4,
      from: "2024/04",
    },
    QUARTERLY: {
      year: 2024,
      month: 2,
      from: "2024/Q2",
    },
  },
  One: {
    MONTHLY: {
      year: 2021,
      month: 4,
      from: "2021/04",
    },
    QUARTERLY: {
      year: 2024,
      month: 2,
      from: "2024/Q2",
    },
  },
};

const monthFilters = [
  {
    id: 1,
    formatted: "01",
  },
  {
    id: 2,
    formatted: "02",
  },
  {
    id: 3,
    formatted: "03",
  },
  {
    id: 4,
    formatted: "04",
  },
  {
    id: 5,
    formatted: "05",
  },
  {
    id: 6,
    formatted: "06",
  },
  {
    id: 7,
    formatted: "07",
  },
  {
    id: 8,
    formatted: "08",
  },
  {
    id: 9,
    formatted: "09",
  },
  {
    id: 10,
    formatted: "10",
  },
  {
    id: 11,
    formatted: "11",
  },
  {
    id: 12,
    formatted: "12",
  },
];

const quarterFilters = [
  {
    month: "Q1",
    id: 1,
    formatted: "Q1",
  },
  {
    month: "Q2",
    id: 2,
    formatted: "Q2",
  },
  {
    month: "Q3",
    id: 3,
    formatted: "Q3",
  },
  {
    month: "Q4",
    id: 4,
    formatted: "Q4",
  },
];

// URL slugs for the dashboard tabs - the last path segment of /dashboard/...
const DASHBOARD_TABS = {
  SETTLEMENTS: "settlements",
  CALENDAR: "calendar",
  RENTAL_INFO: "rental-info",
  SETTLEMENT_RULES: "settlement-rules",
  LANDLORD_INFO: "landlord-info",
  INVOICES: "invoices",
  FAQ: "faq",
};

const DEFAULT_DASHBOARD_TAB = DASHBOARD_TABS.SETTLEMENTS;

const ADMIN_ONLY_TABS = [DASHBOARD_TABS.LANDLORD_INFO];

export {
  monthFilters,
  quarterFilters,
  COLORS,
  CALENDAR_COLORS,
  CUT_OFF,
  BRAND_LOGOS,
  COMPANY_INFO,
  DASHBOARD_TABS,
  DEFAULT_DASHBOARD_TAB,
  ADMIN_ONLY_TABS,
};
